import sign from '../signageEndpoint'

module.exports = {
	// LAYOUTS
	getLayouts (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/layout',
				data: {
					location_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createLayout (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/layout',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deleteLayout (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/layout/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// ZONES
	getZones (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/zone',
				data: {
					layout_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createZone (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/zone',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	updateZones (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PATCH',
				dataType: 'json',
				url: '/zone/' + obj.zone_id,
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deleteZone (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/zone/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Presentations
	getPresentations (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/presentation',
				data: {
					location_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createPresentation (str, id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/presentation',
				data: {
					name: str,
					location_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deletePresentation (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/presentation/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Layout playlist
	getLayoutPlaylists (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/layout_playlist',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createLayoutPlaylist (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/layout_playlist',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deleteLayoutPlaylist (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/layout_playlist/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Layout playlist Entries
	getLayoutPlaylistEntries (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/layout_playlist_entry',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createLayoutPlaylistEntry (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/layout_playlist_entry',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deleteLayoutPlaylistEntry (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/layout_playlist_entry/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Schedules
	getSchedules (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/schedule',
				data: {
					location_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createSchedule (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/schedule',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deleteSchedule (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/schedule/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Schedules Entries
	getScheduleEntries (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/schedule_entry',
				data: {
					schedule_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createScheduleEntry (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/schedule_entry',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deleteScheduleEntry (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/schedule_entry/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Playlists
	getPlaylists (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/playlist',
				data: {
					presentation_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createPlaylist (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/playlist',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deletePlaylist (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/playlist/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	// Playlists Entries
	getPlaylistEntries (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/playlist_entry',
				data: {
					playlist_id: id
				},
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	createPlaylistEntry (obj) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/playlist_entry',
				data: obj,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	},
	deletePlaylistEntry (id) {
		return new Promise((resolve, reject) => {
			sign.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/playlist_entry/' + id,
				success (response) {
					resolve(response)
				},
				error (e) {
					reject(e)
				}
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/controllers/Signage.js